var exports = {
  "Nr": "x234b8571--b2ea3a--card",
  "ii": "x234b8571--b2ea3a--card--xs",
  "Rz": "x234b8571--b2ea3a--card__close",
  "Kd": "x234b8571--b2ea3a--card__image",
  "Ux": "x234b8571--b2ea3a--card__promo",
  "jL": "x234b8571--b2ea3a--card__body",
  "DW": "x234b8571--b2ea3a--card__body-item",
  "kk": "x234b8571--b2ea3a--card__labels",
  "fT": "x234b8571--b2ea3a--card__title",
  "dv": "x234b8571--b2ea3a--card__reliable",
  "TZ": "x234b8571--b2ea3a--card__apartments-search",
  "go": "x234b8571--b2ea3a--card__apartments",
  "lZ": "x234b8571--b2ea3a--phone",
};

module.exports = exports;
